import boolACadenaFilter from "../../filtros/bool.a.cadena.filter";
import diasSemanaFilter from "../../filtros/dias-semana.filter";

export default class BeneficioLogic {
    // El underscore (_) indica que es una variable "privada" y no debería ser usada afuera
    static _columnasAdministrador = [
        {
            clave: "nombreComercio",
            cabecera: "Comercio"
        },
        {
            clave: "nombre",
            cabecera: "Nombre",
        },
        {
            clave: "permiteInvitado",
            cabecera: "Permite Invitado",
            transformacion: {
                filtro: boolACadenaFilter,
                argumentos: ["Si", "No"],
            },
        },
        {
            clave: "medioPago",
            cabecera: "Medio de Pago",
        },
        {
            clave: 'diasHabilitados',
            cabecera: 'Días Habilitados',
            transformacion: {
                filtro: diasSemanaFilter
            }
        }
    ]

    // El underscore (_) indica que es una variable "privada"
    static _columnasComerciante = [
        {
            clave: "nombre",
            cabecera: "Nombre",
        },
        {
            clave: "permiteInvitado",
            cabecera: "Permite Invitado",
            transformacion: {
                filtro: boolACadenaFilter,
                argumentos: ["Si", "No"],
            },
        },
        {
            clave: "medioPago",
            cabecera: "Medio de Pago",
        },
        {
            clave: 'diasHabilitados',
            cabecera: 'Días Habilitados',
            transformacion: {
                filtro: diasSemanaFilter
            }
        }
    ];

    // El underscore (_) indica que es una variable "privada"
    static _columnasComercianteRechazados = [
        {
            clave: "nombre",
            cabecera: "Nombre",
        },        
        {
            clave: "motivo",
            cabecera: "Motivo de rechazo",
        }
        
    ];

    static get ColumnasAdministrador() {
        return BeneficioLogic._columnasAdministrador;
    }
    static get ColumnasComerciante() {
        return BeneficioLogic._columnasComerciante;
    }
    static get ColumnasComercianteRechazados() {
        return BeneficioLogic._columnasComercianteRechazados;
    }
}